export const videoInput = {
  invalidLink:
    "That doesn't look like a video link. Paste a URL from YouTube, Twitch, Vimeo, Loom, Google Drive, Dropbox — or a direct video file link.",
  // Rotating token at the END of the placeholder sentence, so width changes push
  // against empty space instead of shifting trailing text.
  placeholderPrefix: "Drop a file or paste a link from ",
  placeholderStatic: "Drop a file or paste a video link",
  anyVideoUrl: "any video URL",
  drop: "Drop!",
  uploadTooltip: "Upload a video file",
  cancel: "Cancel",
  generate: "Generate",
  uploadFirst: "Please upload a video file",
  signIn: "Sign in to get started",
  fileTypes: "Only mp4, webm and mov files are supported",
  fileTooLarge: "File too large (Max 10GB)",
};
